// extracted by mini-css-extract-plugin
export default {"loader":"ProcessingStage_loader__hrDM3","text":"ProcessingStage_text__GasXp"};